import { Union, Record } from "../fable_modules/fable-library.3.7.1/Types.js";
import { union_type, option_type, lambda_type, class_type, record_type, int32_type, string_type } from "../fable_modules/fable-library.3.7.1/Reflection.js";
import { columnDef_header_Z5FD1F5D2, columnDef_id_Z721C83C5, columnDef_accessorFn_77A7E8C8, columnDef_cell_Z1DDB00E5, columnDef_accessorKey_Z721C83C5, columnDef_columns_Z2906D979, columnDef_footer_Z5FD1F5D2, columnDef_header_Z721C83C5 } from "../../Feliz.TanStack.Table/ColumnDef.fs.js";
import { singleton as singleton_1, ofArray } from "../fable_modules/fable-library.3.7.1/List.js";
import { createElement } from "react";
import { ColumnResizeMode, ColumnResizeMode_toString_21C97CDE, ColumnResizeMode$reflection } from "../../Feliz.TanStack.Table/Types.fs.js";
import { nonSeeded } from "../fable_modules/fable-library.3.7.1/Random.js";
import { Table_getRowModel_Z4395D14A, Table_getVisibleCells_773C3262, Table_getContext_Z78EF7AD2, Table_getHeaderGroups_Z4395D14A, Table_getContext_315F98D7, Html_flexRender_Z6DEE00B4, Table_init_Z5C3B000E } from "../../Feliz.TanStack.Table/Table.fs.js";
import { tableProps_columns_Z2906D979 } from "../../Feliz.TanStack.Table/TableProps.fs.js";
import { Cmd_none } from "../fable_modules/Fable.Elmish.4.0.0-beta-3/cmd.fs.js";
import { Table_getCenterTotalSize_Z4395D14A, Table_getDeltaOffset_Z4395D14A, Column_getIsResizing_Z2685F962, Header_getSize_315F98D7, Table_setColumnSizingMode, Header_endResize_Z4395D14A, Header_resizeHandler } from "../../Feliz.TanStack.Table/Sizing.fs.js";
import { empty, singleton, append, map, delay, toList } from "../fable_modules/fable-library.3.7.1/Seq.js";
import { equals, partialApply, createObj } from "../fable_modules/fable-library.3.7.1/Util.js";
import { join } from "../fable_modules/fable-library.3.7.1/String.js";
import { Interop_reactApi } from "../fable_modules/Feliz.1.67.0/Interop.fs.js";
import { useFeliz_React__React_useElmish_Static_B42E862 } from "../fable_modules/Feliz.UseElmish.1.6.0/UseElmish.fs.js";

export class Person extends Record {
    constructor(Firstname, Lastname, Age, Visits, Status, Progress) {
        super();
        this.Firstname = Firstname;
        this.Lastname = Lastname;
        this.Age = (Age | 0);
        this.Visits = (Visits | 0);
        this.Status = Status;
        this.Progress = (Progress | 0);
    }
}

export function Person$reflection() {
    return record_type("Examples.Resizing.Person", [], Person, () => [["Firstname", string_type], ["Lastname", string_type], ["Age", int32_type], ["Visits", int32_type], ["Status", string_type], ["Progress", int32_type]]);
}

export const defaultData = [new Person("Ruthie", "Hirthe", 2, 217, "single", 96), new Person("Domenico", "Swift", 7, 497, "relationship", 70), new Person("Omer", "Zboncak", 13, 667, "complicated", 12)];

export const defaultColumns = ofArray([ofArray([columnDef_header_Z721C83C5("Name"), columnDef_footer_Z5FD1F5D2((props) => props.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Firstname"), columnDef_cell_Z1DDB00E5((info) => info.getValue()), columnDef_footer_Z5FD1F5D2((props_1) => props_1.column.id)]), ofArray([columnDef_accessorFn_77A7E8C8((p) => p.Lastname), columnDef_id_Z721C83C5("Lastname"), columnDef_cell_Z1DDB00E5((info_1) => info_1.getValue()), columnDef_header_Z5FD1F5D2((_arg1) => createElement("span", {
    children: "Last Name",
})), columnDef_footer_Z5FD1F5D2((props_3) => props_3.column.id)])]))]), ofArray([columnDef_header_Z721C83C5("Info"), columnDef_footer_Z5FD1F5D2((props_4) => props_4.column.id), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Age"), columnDef_header_Z5FD1F5D2((_arg2) => "Age"), columnDef_footer_Z5FD1F5D2((props_5) => props_5.column.id)]), ofArray([columnDef_header_Z721C83C5("More Info"), columnDef_columns_Z2906D979(ofArray([ofArray([columnDef_accessorKey_Z721C83C5("Visits"), columnDef_header_Z5FD1F5D2((_arg3) => createElement("span", {
    children: "Visits",
})), columnDef_footer_Z5FD1F5D2((props_7) => props_7.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Status"), columnDef_header_Z721C83C5("Status"), columnDef_footer_Z5FD1F5D2((props_8) => props_8.column.id)]), ofArray([columnDef_accessorKey_Z721C83C5("Progress"), columnDef_header_Z721C83C5("Profile Progress"), columnDef_footer_Z5FD1F5D2((props_9) => props_9.column.id)])]))])]))])]);

export class State extends Record {
    constructor(Table, ResizeMode, ResizingHandler) {
        super();
        this.Table = Table;
        this.ResizeMode = ResizeMode;
        this.ResizingHandler = ResizingHandler;
    }
}

export function State$reflection() {
    return record_type("Examples.Resizing.State", [], State, () => [["Table", class_type("Feliz.TanStack.Table.Types.Table`1", [Person$reflection()])], ["ResizeMode", ColumnResizeMode$reflection()], ["ResizingHandler", option_type(lambda_type(class_type("Browser.Types.Event"), class_type("Feliz.TanStack.Table.Types.Table`1", [Person$reflection()])))]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ResizeModeChange", "BeginResize", "Resize", "EndResize"];
    }
}

export function Msg$reflection() {
    return union_type("Examples.Resizing.Msg", [], Msg, () => [[["Item", ColumnResizeMode$reflection()]], [["Item1", class_type("Browser.Types.Event")], ["Item2", class_type("Feliz.TanStack.Table.Types.Header`1", [Person$reflection()])]], [["Item1", class_type("Browser.Types.Event")], ["Item2", lambda_type(class_type("Browser.Types.Event"), class_type("Feliz.TanStack.Table.Types.Table`1", [Person$reflection()]))]], []]);
}

const rand = nonSeeded();

export function init() {
    return [new State(Table_init_Z5C3B000E(ofArray([["data", defaultData], tableProps_columns_Z2906D979(defaultColumns), ["columnResizeMode", ColumnResizeMode_toString_21C97CDE(new ColumnResizeMode(0))], ["enableColumnResizing", true]])), new ColumnResizeMode(0), void 0), Cmd_none()];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1: {
            return [new State(state.Table, state.ResizeMode, Header_resizeHandler(msg.fields[0], msg.fields[1], state.Table)), Cmd_none()];
        }
        case 2: {
            return [new State(msg.fields[1](msg.fields[0]), state.ResizeMode, state.ResizingHandler), Cmd_none()];
        }
        case 3: {
            if (state.ResizingHandler == null) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(Header_endResize_Z4395D14A(state.Table), state.ResizeMode, void 0), Cmd_none()];
            }
        }
        default: {
            const resizeMode = msg.fields[0];
            return [new State(Table_setColumnSizingMode(resizeMode, state.Table), resizeMode, state.ResizingHandler), Cmd_none()];
        }
    }
}

export function view(state, dispatch) {
    let elems_4, properties_7, elems_7, elems_6, elems_5;
    const beginResize = (h, e) => {
        dispatch(new Msg(1, e, h));
    };
    const move = (e_1) => {
        const matchValue = state.ResizingHandler;
        if (matchValue == null) {
        }
        else {
            dispatch(new Msg(2, e_1, matchValue));
        }
    };
    const endResize = (_arg1) => {
        dispatch(new Msg(3));
    };
    let table;
    let thead;
    const children = toList(delay(() => map((headerGroup) => {
        let properties, elems_1;
        return createElement("tr", createObj(ofArray([["key", headerGroup.id], (properties = ofArray([["height", 30 + "px"], ["width", "fit-content"]]), ["style", createObj(properties)]), (elems_1 = toList(delay(() => map((header) => {
            let properties_1, elems;
            return createElement("th", createObj(ofArray([["onMouseMove", move], ["onTouchMove", move], ["key", header.id], ["colSpan", header.colSpan], (properties_1 = ofArray([["width", Header_getSize_315F98D7(header)], ["position", "relative"]]), ["style", createObj(properties_1)]), (elems = toList(delay(() => append(header.isPlaceholder ? singleton(null) : singleton(Html_flexRender_Z6DEE00B4(header.column.columnDef.header, Table_getContext_315F98D7(header))), delay(() => {
                let clo1, clo1_1, properties_2;
                return singleton(createElement("div", createObj(ofArray([["onMouseDown", (clo1 = partialApply(1, beginResize, [header]), clo1)], ["onTouchStart", (clo1_1 = partialApply(1, beginResize, [header]), clo1_1)], (properties_2 = toList(delay(() => ((Column_getIsResizing_Z2685F962(header.column) && equals(state.ResizeMode, new ColumnResizeMode(1))) ? singleton(["transform", ("translateX(" + (Table_getDeltaOffset_Z4395D14A(state.Table) + "px")) + ")"]) : empty()))), ["style", createObj(properties_2)]), ["className", join(" ", toList(delay(() => append(singleton("resizer"), delay(() => (Column_getIsResizing_Z2685F962(header.column) ? singleton("isResizing") : empty()))))))]]))));
            })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
        }, headerGroup.headers))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
    }, Table_getHeaderGroups_Z4395D14A(state.Table))));
    thead = createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    let tbody;
    const children_4 = toList(delay(() => map((row) => {
        let elems_2;
        return createElement("tr", createObj(ofArray([["key", row.id], (elems_2 = toList(delay(() => map((cell) => {
            const children_2 = singleton_1(Html_flexRender_Z6DEE00B4(cell.column.columnDef.cell, Table_getContext_Z78EF7AD2(cell)));
            return createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_2)),
            });
        }, Table_getVisibleCells_773C3262(row)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }, Table_getRowModel_Z4395D14A(state.Table).rows)));
    tbody = createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_4)),
    });
    table = createElement("div", createObj(ofArray([["className", join(" ", ["p-2"])], (elems_4 = [createElement("table", createObj(ofArray([(properties_7 = singleton_1(["width", Table_getCenterTotalSize_Z4395D14A(state.Table)]), ["style", createObj(properties_7)]), ["children", Interop_reactApi.Children.toArray([thead, tbody])]])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])));
    return createElement("div", createObj(ofArray([["onMouseUp", endResize], ["onMouseLeave", endResize], ["onTouchEnd", endResize], (elems_7 = [createElement("div", createObj(ofArray([["className", join(" ", ["field"])], (elems_6 = [createElement("select", createObj(ofArray([["className", join(" ", ["select"])], ["onChange", (e_2) => {
        const matchValue_1 = [e_2.target.value, state.ResizeMode];
        let pattern_matching_result;
        if (matchValue_1[0] === "onChange") {
            if (matchValue_1[1].tag === 1) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else if (matchValue_1[0] === "onEnd") {
            if (matchValue_1[1].tag === 0) {
                pattern_matching_result = 1;
            }
            else {
                pattern_matching_result = 2;
            }
        }
        else {
            pattern_matching_result = 2;
        }
        switch (pattern_matching_result) {
            case 0: {
                dispatch(new Msg(0, new ColumnResizeMode(0)));
                break;
            }
            case 1: {
                dispatch(new Msg(0, new ColumnResizeMode(1)));
                break;
            }
            case 2: {
                break;
            }
        }
    }], ["value", ColumnResizeMode_toString_21C97CDE(state.ResizeMode)], (elems_5 = [createElement("option", {
        children: "onChange",
    }), createElement("option", {
        children: "onEnd",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]))), table], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function Component() {
    const patternInput = useFeliz_React__React_useElmish_Static_B42E862(init, update);
    return view(patternInput[0], patternInput[1]);
}

//# sourceMappingURL=Resizing.fs.js.map
